(function ($, Drupal, once) {

  'use strict';

  const container = document;

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Globally accessible API
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Promutuel.mutualCards = {
    // Methods

    personalizeUI(mutualId) {
      [...document.querySelectorAll('.js-mutualcard')].forEach(card => {
        if (parseInt(card.dataset.mutualId, 10) === mutualId)
          this.displayCardAsMyMutual(card);
        else
          this.displayCardAsNotMyMutual(card);
      });
    },
    displayCardAsMyMutual: function (card) {
      card.querySelector('.js-mutualcard-isnotset')?.classList.add('d-none');
      card.querySelector('.js-mutualcard-isset')?.classList.remove('d-none');
    },
    displayCardAsNotMyMutual: function (card) {
      card.querySelector('.js-mutualcard-isnotset')?.classList.remove('d-none');
      card.querySelector('.js-mutualcard-isset')?.classList.add('d-none');
    },
  }

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

  Drupal.behaviors.promutuel_mutualCard = {
    attach: function attach(context) {

      
      $(once('promutuelMutualCard', 'html', context)).each(function () {
        container.querySelectorAll('.js-mutualcard-set').forEach(node => {
          node.addEventListener('click', event => {
            event.preventDefault();
            // Select the card containing the button that was clicked.
            const card = event.target.closest('[data-mutual-id]');
            Promutuel.mutuals.setMyMutual({ id: card?.dataset.mutualId });
          });
        });
      });
    }
  };

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Utilities
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */

})(jQuery, Drupal, once);
